// @core/api/endpoints/fiscalization/update_fiscal_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateFiscalProviderRequest,
  UpdateFiscalProviderResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Update fiscal provider
 * Updates fiscal provider configuration such as endpoint URL, protocol version, or status.
 */
export async function UpdateFiscalProvider(
  id: string,
  data: UpdateFiscalProviderRequest,
  options?: RequestOptions
): Promise<UpdateFiscalProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateFiscalProviderResponse>(requestPath, data, requestOptions);
}
